export default __webpack_public_path__ + "static/media/Mechanical-Keyboard-single-button-presses-4.80c7246f.mp3";